import { useState } from 'react';
import { LANGUAGE_OPTIONS, LanguageOption, LanguageContext } from './LanguageContext';
import { changeLanguage } from 'i18next';

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [selectedLanguage, setSelectedLanguage] = useState<LanguageOption>(LANGUAGE_OPTIONS[0]);

  const setLanguage = (language: LanguageOption) => {
    setSelectedLanguage(language);
    changeLanguage(language.value);
    document.documentElement.lang = language.value;
  };

  return (
    <LanguageContext.Provider
      value={{ selectedLanguage, setLanguage, languageOptions: LANGUAGE_OPTIONS }}
    >
      {children}
    </LanguageContext.Provider>
  );
}
